import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { sendEvent } from 'src/shared/api/events/send-event'
import { useMyUserData } from 'src/shared/features/users/api/accounts/use-my-user'
import { useEventStore } from 'src/shared/store/event-store'

export const usePageView = () => {
  const location = useLocation()
  const { anonymousId, sessionId, setSessionId, gclid, fbclid, utmParams } = useEventStore()
  const { data: currentUser } = useMyUserData()

  useEffect(() => {
    if (!sessionId) {
      setSessionId()
    }
  }, [sessionId, setSessionId])

  useEffect(() => {
    const eventData = {
      eventType: 'page_view',
      info: {
        path: location.pathname,
        search: location.search,
        sessionId: sessionId || undefined,
        ...(gclid ? { gclid } : {}),
        ...(fbclid ? { fbclid } : {}),
        ...(utmParams?.source ? { utm_source: utmParams.source } : {}),
        ...(utmParams?.medium ? { utm_medium: utmParams.medium } : {}),
        ...(utmParams?.campaign ? { utm_campaign: utmParams.campaign } : {}),
        ...(utmParams?.term ? { utm_term: utmParams.term } : {}),
      },
    } as const

    if (currentUser) {
      sendEvent({
        ...eventData,
        userId: currentUser.id,
      })
    } else {
      sendEvent({
        ...eventData,
        anonymousId: anonymousId || undefined,
      })
    }
  }, [location.pathname, location.search, anonymousId, sessionId, currentUser])
}
